'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const components_forms_Dropdown_Dropdown = require('../../forms/Dropdown/Dropdown.cjs.js');
const components_patterns_ServiceIcon_ServiceIcon = require('../ServiceIcon/ServiceIcon.cjs.js');

const Styles = styleEncapsulation.labelStyles("ServiceDropdown", {
  serviceIcon: react.css`
    &[data-disabled] {
      opacity: 0.6;
    }
  `
});
const ServiceDropdown = (_a) => {
  var { getIconUrlForItem } = _a, props = tslib_es6.__rest(_a, ["getIconUrlForItem"]);
  const renderIcon = (item) => !!item && react.jsx(
    "span",
    { css: Styles.serviceIcon, "data-disabled": props.isDisabled ? "" : void 0, "data-zds": true },
    react.jsx(components_patterns_ServiceIcon_ServiceIcon.ServiceIcon, { "aria-hidden": true, serviceName: props.getLabelForItem(item), size: "small", src: getIconUrlForItem(item) })
  );
  return react.jsx(components_forms_Dropdown_Dropdown.Dropdown, Object.assign({}, props, { renderIcon }));
};

exports.ServiceDropdown = ServiceDropdown;
//# sourceMappingURL=ServiceDropdown.cjs.js.map
